// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 건별수익률현황 화면 */

.memo-cell {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 메모 없어도 클릭 가능 — 매수등록 화면으로 이동 */
.memo-cell-clickable {
  cursor: pointer;
  min-height: 1em;
}
.memo-cell-clickable:hover {
  background: #eef4fc;
  text-decoration: underline;
}

/* '전체'/'종목별' 탭에서 매도일이 있는(실제 체결된) 매도금액만 클릭 가능 →
   매도등록 화면으로 이동, 해당 매도건 선택 (매도계획 등 미체결 행은 제외) */
.sell-amount-cell-clickable {
  cursor: pointer;
}
.sell-amount-cell-clickable:hover {
  background: #eef4fc;
  text-decoration: underline;
}

/* 종목별 탭 차수 클릭 → 2개종목비교 팝업 */
.turn-no-compare-link {
  cursor: pointer;
  color: #1A73E8;
  text-decoration: underline;
}
.turn-no-compare-link:hover {
  color: #0d47a1;
}

/* ── 필터 영역 ── */
.profit-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}

.profit-select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

.profit-year-select { width: 72px; }

.profit-chk {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.profit-chk input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

/* ── 합계 구분자 ── */
.profit-sep {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #ccc;
  margin: 0 2px;
  vertical-align: middle;
  flex-shrink: 0;
}

/* ── 합계 항목 ── */
.profit-summary-item {
  font-size: 12px;
  color: #444;
  white-space: nowrap;
}

.profit-summary-item strong {
  font-weight: 700;
}

/* ── 컬럼 리사이즈 핸들 ── */
.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.col-resize-handle:hover {
  background: rgba(0, 0, 0, 0.15);
}

/* ── 바디 ── */
.profit-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  gap: 8px;
}

/* ── 지표 비교 영역 (보유/매수 무관 순수 시세 워치리스트) ──
   .benchmark-bar는 .profit-body의 첫 자식이라 위쪽엔 flex gap이 안 붙어서
   margin-top 0이면 조회영역 바로 아래에 붙는다. 아래쪽은 .profit-body의
   flex gap(8px)이 이미 있어서 margin-bottom을 -4px로 상쇄해 최종 4px만 남긴다. */
.benchmark-bar {
  flex-shrink: 0;
  margin-top: 0;
  margin-bottom: -4px;
}

.benchmark-panel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  padding: 4px 0;
  font-size: 12px;
}

.benchmark-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  white-space: nowrap;
  cursor: pointer;
}

.benchmark-chip:hover .benchmark-chip-name { text-decoration: underline; }

.benchmark-chip-name {
  font-weight: 600;
  color: #1a1a2e;
}

.benchmark-chip-price {
  color: #333;
}

.benchmark-chip-rate {
  font-weight: 600;
}

.benchmark-divider {
  color: #ccc;
  font-weight: 300;
  margin: 0 2px;
}

/* ── 탭 버튼 영역 ── */
.profit-inner-tabs {
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
}

.inner-tab-btn {
  padding: 5px 16px;
  font-size: 12px;
  font-family: inherit;
  font-weight: 600;
  border: 1px solid #ddd;
  border-right: none;
  background: white;
  color: #555;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.inner-tab-btn:first-child { border-radius: 4px 0 0 4px; }
.inner-tab-btn:last-of-type { border-right: 1px solid #ddd; border-radius: 0 4px 4px 0; }

.inner-tab-btn.active {
  background: #1a1a2e;
  color: white;
  border-color: #1a1a2e;
}

.inner-tab-btn:hover:not(.active) { background: #f0f4ff; }

/* ── 시세 상태 표시 ── */
.price-status {
  margin-left: 12px;
  font-size: 11px;
}

.price-status.loading  { color: #888; }
.price-status.realtime { color: #0a8a00; }
.price-status.mixed    { color: #888; }

/* ── 자동갱신 체크박스 (탭 행 오른쪽 끝) ── */
.auto-refresh-chk {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 10px;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #7dbb7d;
  border: 1px solid #b8ddb8;
  background: #f4fbf4;
  white-space: nowrap;
  transition: color 0.2s, border-color 0.2s, background 0.2s;
}

.auto-refresh-chk input[type="checkbox"] {
  cursor: pointer;
  accent-color: #2e7d32;
}

/* 체크 상태 */
.auto-refresh-chk.active {
  color: #1b5e20;
  border-color: #4caf50;
  background: #e8f5e9;
  font-weight: 600;
}

/* 시세조회중 (체크 + priceLoading) */
.auto-refresh-chk.fetching {
  color: #2e7d32;
  animation: auto-refresh-pulse 1.2s ease-in-out infinite;
}

@keyframes auto-refresh-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.45; }
}

/* 수동 시세갱신 버튼 */
.profit-refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: white;
  font-size: 15px;
  cursor: pointer;
  color: #555;
  margin-left: 4px;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;
  transition: color 0.2s, border-color 0.2s;
}

.profit-refresh-btn:hover:not(:disabled) {
  color: #3050c8;
  border-color: #3050c8;
}

.profit-refresh-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.profit-refresh-btn.spinning {
  animation: spin 1s linear infinite;
}

/* 엑셀 다운로드 버튼 */
.profit-excel-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  background: #217346;
  color: white;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s;
}

.profit-excel-btn:hover:not(:disabled) {
  background: #1a5c38;
}

.profit-excel-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

/* 현재가 헤더 스피너 */
.col-spinner {
  display: inline-block;
  margin-left: 3px;
  color: #888;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── 정렬 가능 컬럼 헤더 ── */
.sortable-col {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sortable-col:hover { background: #e8ecf8 !important; }

.sort-arrow {
  font-size: 10px;
  color: #4a6cf7;
}

/* ── 그리드 래퍼 ── */
.profit-grid-wrapper {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #dde2ef;
  border-radius: 4px;
  background: white;
}

/* ── 그리드 폰트 ── */
.profit-grid td,
.profit-grid th {
  font-size: 12px;
  white-space: nowrap;
}

/* ── 미매도 행 ── */
.row-unsold { background: white; }

/* ── 매도완료 행 ── */
.row-sold {
  background: #f7f7f7;
  color: #888;
}

/* ── 그룹 헤더 행 ── */
.row-group-header {
  background: #2c3e6b !important;
  cursor: default !important;
}

.row-group-header td {
  color: #fff !important;
  font-weight: 700;
  font-size: 12px;
  padding: 6px 10px;
}

.group-count {
  font-weight: 400;
  font-size: 11px;
  opacity: 0.8;
}

/* ── 소계 행 ── */
.row-subtotal {
  background: #eef1f8 !important;
  cursor: default !important;
}

.row-subtotal td {
  font-weight: 700;
  font-size: 12px;
  border-bottom: 2px solid #c8cfe8 !important;
}

/* ── 합계 행 ── */
.row-total {
  background: #d0d7ee !important;
  cursor: default !important;
  position: sticky;
  bottom: 0;
  z-index: 1;
}

.row-total td {
  font-weight: 700;
  font-size: 12px;
  border-top: 2px solid #a0aad0 !important;
  border-bottom: none !important;
}

/* ── 소계/합계 라벨 셀 ── */
.summary-label {
  text-align: right !important;
  color: #444;
  padding-right: 14px !important;
}

.row-total .summary-label { color: #1a1a2e; }

/* ── 매도완료 행은 색상 약하게 ── */
.row-sold .profit-pos { color: #5a9ad0 !important; font-weight: normal !important; }
.row-sold .profit-neg { color: #d67070 !important; font-weight: normal !important; }
`, "",{"version":3,"sources":["webpack://./src/pages/status/ProfitStatusPage.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;+CAC+C;AAC/C;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,sBAAsB,WAAW,EAAE;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,QAAQ;AACV;;AAEA;;;gEAGgE;AAChE;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6CAA6C,0BAA0B,EAAE;;AAEzE;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yCAAyC;AAC3C;;AAEA,6BAA6B,0BAA0B,EAAE;AACzD,8BAA8B,4BAA4B,EAAE,0BAA0B,EAAE;;AAExF;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,yBAAyB,WAAW,EAAE;AACtC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,WAAW,EAAE;;AAEtC,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,aAAa,EAAE;AAC7B;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,sBAAsB,8BAA8B,EAAE;;AAEtD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB,cAAc,iBAAiB,EAAE;;AAEjC,iBAAiB;AACjB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;EAC5B,WAAW;EACX,8BAA8B;AAChC;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C,yBAAyB;AACzB,wBAAwB,yBAAyB,EAAE,8BAA8B,EAAE;AACnF,wBAAwB,yBAAyB,EAAE,8BAA8B,EAAE","sourcesContent":["/* 건별수익률현황 화면 */\n\n.memo-cell {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* 메모 없어도 클릭 가능 — 매수등록 화면으로 이동 */\n.memo-cell-clickable {\n  cursor: pointer;\n  min-height: 1em;\n}\n.memo-cell-clickable:hover {\n  background: #eef4fc;\n  text-decoration: underline;\n}\n\n/* '전체'/'종목별' 탭에서 매도일이 있는(실제 체결된) 매도금액만 클릭 가능 →\n   매도등록 화면으로 이동, 해당 매도건 선택 (매도계획 등 미체결 행은 제외) */\n.sell-amount-cell-clickable {\n  cursor: pointer;\n}\n.sell-amount-cell-clickable:hover {\n  background: #eef4fc;\n  text-decoration: underline;\n}\n\n/* 종목별 탭 차수 클릭 → 2개종목비교 팝업 */\n.turn-no-compare-link {\n  cursor: pointer;\n  color: #1A73E8;\n  text-decoration: underline;\n}\n.turn-no-compare-link:hover {\n  color: #0d47a1;\n}\n\n/* ── 필터 영역 ── */\n.profit-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.profit-select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n.profit-year-select { width: 72px; }\n\n.profit-chk {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #333;\n  cursor: pointer;\n  user-select: none;\n}\n\n.profit-chk input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\n/* ── 합계 구분자 ── */\n.profit-sep {\n  display: inline-block;\n  width: 1px;\n  height: 14px;\n  background: #ccc;\n  margin: 0 2px;\n  vertical-align: middle;\n  flex-shrink: 0;\n}\n\n/* ── 합계 항목 ── */\n.profit-summary-item {\n  font-size: 12px;\n  color: #444;\n  white-space: nowrap;\n}\n\n.profit-summary-item strong {\n  font-weight: 700;\n}\n\n/* ── 컬럼 리사이즈 핸들 ── */\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.col-resize-handle:hover {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* ── 바디 ── */\n.profit-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  gap: 8px;\n}\n\n/* ── 지표 비교 영역 (보유/매수 무관 순수 시세 워치리스트) ──\n   .benchmark-bar는 .profit-body의 첫 자식이라 위쪽엔 flex gap이 안 붙어서\n   margin-top 0이면 조회영역 바로 아래에 붙는다. 아래쪽은 .profit-body의\n   flex gap(8px)이 이미 있어서 margin-bottom을 -4px로 상쇄해 최종 4px만 남긴다. */\n.benchmark-bar {\n  flex-shrink: 0;\n  margin-top: 0;\n  margin-bottom: -4px;\n}\n\n.benchmark-panel {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  padding: 4px 0;\n  font-size: 12px;\n}\n\n.benchmark-chip {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 3px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.benchmark-chip:hover .benchmark-chip-name { text-decoration: underline; }\n\n.benchmark-chip-name {\n  font-weight: 600;\n  color: #1a1a2e;\n}\n\n.benchmark-chip-price {\n  color: #333;\n}\n\n.benchmark-chip-rate {\n  font-weight: 600;\n}\n\n.benchmark-divider {\n  color: #ccc;\n  font-weight: 300;\n  margin: 0 2px;\n}\n\n/* ── 탭 버튼 영역 ── */\n.profit-inner-tabs {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  flex-shrink: 0;\n}\n\n.inner-tab-btn {\n  padding: 5px 16px;\n  font-size: 12px;\n  font-family: inherit;\n  font-weight: 600;\n  border: 1px solid #ddd;\n  border-right: none;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n\n.inner-tab-btn:first-child { border-radius: 4px 0 0 4px; }\n.inner-tab-btn:last-of-type { border-right: 1px solid #ddd; border-radius: 0 4px 4px 0; }\n\n.inner-tab-btn.active {\n  background: #1a1a2e;\n  color: white;\n  border-color: #1a1a2e;\n}\n\n.inner-tab-btn:hover:not(.active) { background: #f0f4ff; }\n\n/* ── 시세 상태 표시 ── */\n.price-status {\n  margin-left: 12px;\n  font-size: 11px;\n}\n\n.price-status.loading  { color: #888; }\n.price-status.realtime { color: #0a8a00; }\n.price-status.mixed    { color: #888; }\n\n/* ── 자동갱신 체크박스 (탭 행 오른쪽 끝) ── */\n.auto-refresh-chk {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-left: 10px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  user-select: none;\n  color: #7dbb7d;\n  border: 1px solid #b8ddb8;\n  background: #f4fbf4;\n  white-space: nowrap;\n  transition: color 0.2s, border-color 0.2s, background 0.2s;\n}\n\n.auto-refresh-chk input[type=\"checkbox\"] {\n  cursor: pointer;\n  accent-color: #2e7d32;\n}\n\n/* 체크 상태 */\n.auto-refresh-chk.active {\n  color: #1b5e20;\n  border-color: #4caf50;\n  background: #e8f5e9;\n  font-weight: 600;\n}\n\n/* 시세조회중 (체크 + priceLoading) */\n.auto-refresh-chk.fetching {\n  color: #2e7d32;\n  animation: auto-refresh-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes auto-refresh-pulse {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.45; }\n}\n\n/* 수동 시세갱신 버튼 */\n.profit-refresh-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #ccc;\n  border-radius: 50%;\n  background: white;\n  font-size: 15px;\n  cursor: pointer;\n  color: #555;\n  margin-left: 4px;\n  line-height: 1;\n  padding: 0;\n  flex-shrink: 0;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.profit-refresh-btn:hover:not(:disabled) {\n  color: #3050c8;\n  border-color: #3050c8;\n}\n\n.profit-refresh-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.profit-refresh-btn.spinning {\n  animation: spin 1s linear infinite;\n}\n\n/* 엑셀 다운로드 버튼 */\n.profit-excel-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 8px;\n  padding: 5px 12px;\n  border: none;\n  border-radius: 4px;\n  background: #217346;\n  color: white;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.profit-excel-btn:hover:not(:disabled) {\n  background: #1a5c38;\n}\n\n.profit-excel-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* 현재가 헤더 스피너 */\n.col-spinner {\n  display: inline-block;\n  margin-left: 3px;\n  color: #888;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* ── 정렬 가능 컬럼 헤더 ── */\n.sortable-col {\n  cursor: pointer;\n  user-select: none;\n}\n\n.sortable-col:hover { background: #e8ecf8 !important; }\n\n.sort-arrow {\n  font-size: 10px;\n  color: #4a6cf7;\n}\n\n/* ── 그리드 래퍼 ── */\n.profit-grid-wrapper {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n  background: white;\n}\n\n/* ── 그리드 폰트 ── */\n.profit-grid td,\n.profit-grid th {\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* ── 미매도 행 ── */\n.row-unsold { background: white; }\n\n/* ── 매도완료 행 ── */\n.row-sold {\n  background: #f7f7f7;\n  color: #888;\n}\n\n/* ── 그룹 헤더 행 ── */\n.row-group-header {\n  background: #2c3e6b !important;\n  cursor: default !important;\n}\n\n.row-group-header td {\n  color: #fff !important;\n  font-weight: 700;\n  font-size: 12px;\n  padding: 6px 10px;\n}\n\n.group-count {\n  font-weight: 400;\n  font-size: 11px;\n  opacity: 0.8;\n}\n\n/* ── 소계 행 ── */\n.row-subtotal {\n  background: #eef1f8 !important;\n  cursor: default !important;\n}\n\n.row-subtotal td {\n  font-weight: 700;\n  font-size: 12px;\n  border-bottom: 2px solid #c8cfe8 !important;\n}\n\n/* ── 합계 행 ── */\n.row-total {\n  background: #d0d7ee !important;\n  cursor: default !important;\n  position: sticky;\n  bottom: 0;\n  z-index: 1;\n}\n\n.row-total td {\n  font-weight: 700;\n  font-size: 12px;\n  border-top: 2px solid #a0aad0 !important;\n  border-bottom: none !important;\n}\n\n/* ── 소계/합계 라벨 셀 ── */\n.summary-label {\n  text-align: right !important;\n  color: #444;\n  padding-right: 14px !important;\n}\n\n.row-total .summary-label { color: #1a1a2e; }\n\n/* ── 매도완료 행은 색상 약하게 ── */\n.row-sold .profit-pos { color: #5a9ad0 !important; font-weight: normal !important; }\n.row-sold .profit-neg { color: #d67070 !important; font-weight: normal !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
